angular.module('impactx.util').service('DeliveryNoteOCIService', [
    DeliveryNoteOCIService]);

function DeliveryNoteOCIService() {
    var storedURL = null;

    function getURL() {
        if (storedURL) {
            var dataToReturn = storedURL;
            storedURL = null;
            return dataToReturn;
        }
        else {
            return null;
        }
    }

    function storeURL(url) {
        storedURL = url;
    }

    return {
        storeURL: storeURL,
        getURL: getURL
    }

}